import React from "react";
import "./Toggle.css";
import { ToggleProps } from "./Toggle.types";

const Toggle: React.FC<ToggleProps> = ({
    ...props
}) => {

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <label className="switch">
                <input disabled={props.disabled} onChange={(e) => props.onChange(e.currentTarget.checked)} checked={props.checked} type="checkbox" />
                <span className="slider"></span>
            </label>
            {
                props.placeholder &&
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span className="text-text-md text-neutral-500 font-medium">{props.placeholder}</span>
                    {
                        props.supportingText &&
                        <span className="slider-supportingtext">{props.supportingText}</span>
                    }
                </div>
            }
        </div>
    )
};

export default Toggle;